export const GANTT_VIEW_POPOVER_TYPES = {
  absenceInfo: 'absenceInfo',
  employeeInfo: 'employeeInfo',
  timeStripeInfo: 'timeStripeInfo',
  dayEntriesInfo: 'dayEntriesInfo',
};

export const GANTT_VIEW_POPOVER_MODAL_TYPES = {
  absenceForm: 'absenceForm',
  timeStripeForm: 'timeStripeForm',
};

export const GANTT_VIEW_MODALS = {
  deleteTimeStripe: 'deleteTimeStripe',
  confirmRemoving: 'confirmRemoving',
};
